export const PLUGIN_TYPE_SANDBOX = 'sandbox';
export const PLUGIN_TYPE_SKILLGROUP = 'skillgroup';
export const PLUGIN_TYPE_RAG = 'rag';
export const PLUGIN_TYPE_MEMORY = 'memory';
export const PLUGIN_TYPE_INFINI_MEMORY = 'infini_memory';
export const PLUGIN_TYPE_MCP = 'mcp';
export const PLUGIN_TYPE_TOOLKIT = 'tool_kit';
export const PLUGIN_TYPE_USER_TOOLKIT = 'user_toolkit';
export const PLUGIN_TYPE_APPLICATION = 'application';
export const PLUGIN_SUB_TYPE_CLASS = 'class';
export const PLUGIN_SUB_TYPE_INSTANCE = 'instance';
export const PLUGIN_SUB_TYPE_TOOLKIT = 'toolkit';
export const PLUGIN_SUB_TYPE_USER_TOOLKIT = 'user_toolkit';
export const PLUGIN_SUB_TYPE_APPLICATION = 'application';
export const PLUGIN_TYPE_SANDBOX_CLASS = 'sandbox_class';
export const PLUGIN_TYPE_SKILLGROUP_CLASS = 'skillgroup_class';
export const PLUGIN_TYPE_RAG_CLASS = 'rag_class';
export const PLUGIN_TYPE_MEMORY_CLASS = 'memory_class';
export const PLUGIN_TYPE_MCP_CLASS = 'mcp_class';

export function toBackendPluginType(
  pluginType: string,
  pluginSubType: string,
  memoryMode: 'mem0' | 'infini_memory' = 'mem0'
): string {
  if (pluginType === PLUGIN_TYPE_TOOLKIT) {
    return PLUGIN_TYPE_TOOLKIT;
  }
  if (pluginType === PLUGIN_TYPE_USER_TOOLKIT) {
    return PLUGIN_TYPE_USER_TOOLKIT;
  }
  if (pluginType === PLUGIN_TYPE_APPLICATION) {
    return PLUGIN_TYPE_APPLICATION;
  }
  if (pluginType === PLUGIN_TYPE_MEMORY && memoryMode === 'infini_memory') {
    return PLUGIN_TYPE_INFINI_MEMORY;
  }
  if (pluginSubType !== PLUGIN_SUB_TYPE_CLASS) {
    return pluginType;
  }
  if (pluginType === PLUGIN_TYPE_SANDBOX) {
    return PLUGIN_TYPE_SANDBOX_CLASS;
  }
  if (pluginType === PLUGIN_TYPE_SKILLGROUP) {
    return PLUGIN_TYPE_SKILLGROUP_CLASS;
  }
  if (pluginType === PLUGIN_TYPE_RAG) {
    return PLUGIN_TYPE_RAG_CLASS;
  }
  if (pluginType === PLUGIN_TYPE_MEMORY) {
    return PLUGIN_TYPE_MEMORY_CLASS;
  }
  if (pluginType === PLUGIN_TYPE_MCP) {
    return PLUGIN_TYPE_MCP_CLASS;
  }
  return pluginType;
}

export function parseBackendPluginType(pluginType: string): {
  pluginType: string;
  memoryMode?: 'mem0' | 'infini_memory';
  pluginSubType:
    | typeof PLUGIN_SUB_TYPE_CLASS
    | typeof PLUGIN_SUB_TYPE_INSTANCE
    | typeof PLUGIN_SUB_TYPE_TOOLKIT
    | typeof PLUGIN_SUB_TYPE_USER_TOOLKIT
    | typeof PLUGIN_SUB_TYPE_APPLICATION;
} {
  if (pluginType === PLUGIN_TYPE_INFINI_MEMORY) {
    return {
      pluginType: PLUGIN_TYPE_MEMORY,
      pluginSubType: PLUGIN_SUB_TYPE_INSTANCE,
      memoryMode: 'infini_memory',
    };
  }
  if (pluginType === PLUGIN_TYPE_TOOLKIT) {
    return { pluginType: PLUGIN_TYPE_TOOLKIT, pluginSubType: PLUGIN_SUB_TYPE_TOOLKIT };
  }
  if (pluginType === PLUGIN_TYPE_USER_TOOLKIT) {
    return { pluginType: PLUGIN_TYPE_USER_TOOLKIT, pluginSubType: PLUGIN_SUB_TYPE_USER_TOOLKIT };
  }
  if (pluginType === PLUGIN_TYPE_APPLICATION) {
    return { pluginType: PLUGIN_TYPE_APPLICATION, pluginSubType: PLUGIN_SUB_TYPE_APPLICATION };
  }
  if (pluginType === PLUGIN_TYPE_SANDBOX_CLASS) {
    return { pluginType: PLUGIN_TYPE_SANDBOX, pluginSubType: PLUGIN_SUB_TYPE_CLASS };
  }
  if (pluginType === PLUGIN_TYPE_SKILLGROUP_CLASS) {
    return { pluginType: PLUGIN_TYPE_SKILLGROUP, pluginSubType: PLUGIN_SUB_TYPE_CLASS };
  }
  if (pluginType === PLUGIN_TYPE_RAG_CLASS) {
    return { pluginType: PLUGIN_TYPE_RAG, pluginSubType: PLUGIN_SUB_TYPE_CLASS };
  }
  if (pluginType === PLUGIN_TYPE_MEMORY_CLASS) {
    return {
      pluginType: PLUGIN_TYPE_MEMORY,
      pluginSubType: PLUGIN_SUB_TYPE_CLASS,
      memoryMode: 'mem0',
    };
  }
  if (pluginType === PLUGIN_TYPE_MEMORY) {
    return {
      pluginType: PLUGIN_TYPE_MEMORY,
      pluginSubType: PLUGIN_SUB_TYPE_INSTANCE,
      memoryMode: 'mem0',
    };
  }
  if (pluginType === PLUGIN_TYPE_MCP_CLASS) {
    return { pluginType: PLUGIN_TYPE_MCP, pluginSubType: PLUGIN_SUB_TYPE_CLASS };
  }
  if (pluginType === PLUGIN_TYPE_MCP) {
    return { pluginType: PLUGIN_TYPE_MCP, pluginSubType: PLUGIN_SUB_TYPE_INSTANCE };
  }
  return {
    pluginType: pluginType || PLUGIN_TYPE_SANDBOX,
    pluginSubType: PLUGIN_SUB_TYPE_INSTANCE,
  };
}
